import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { helpModalIndex } from './helpModalIndex';
import { HelpModalContext } from './HelpModalContext';

export class HelpModalWrapper extends Component {
  constructor(props) {
    super(props);
    this.renderModal = this.renderModal.bind(this);
    this.toggle = this.toggle.bind(this);
    this.state = {
      open: false,
      modalId: '',
      toggle: this.toggle,
    };
  }

  toggle(modalId) {
    this.setState(({ open: prevOpen, modalId: prevModalId }) => {
      if (prevOpen && prevModalId === modalId) {
        return { modalId: '', open: false };
      }
      return { modalId, open: true };
    });
  }

  renderModal() {
    const { open, toggle, modalId } = this.state;
    const modalConfig = helpModalIndex[modalId];
    if (!open || !modalConfig) {
      return null;
    }
    return (
      <Modal isOpen={open} toggle={toggle}>
        <ModalHeader toggle={toggle}>{modalConfig.title}</ModalHeader>
        <ModalBody>
          <div className="haz-help-modal-body">
            {modalConfig.body}
          </div>
        </ModalBody>
      </Modal>
    );
  }

  render() {
    const { children } = this.props;
    return (
      <div className="haz-help-wrapper">
        <HelpModalContext.Provider value={this.state}>
          {this.renderModal()}
          {children}
        </HelpModalContext.Provider>
      </div>
    );
  }
}

HelpModalWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};
